export const environment = {
  production: false,
  url_test:'https://api.aljhamar.com',
  url: 'https://api.aljhamar.com',
  firebase: {
    apiKey: 'AIzaSyAfFjG-bfiGrmq2M4OrnE3MFiuXG750j3o',
    authDomain: 'aljhamar-7d834.firebaseapp.com',
    projectId: 'aljhamar-7d834',
    storageBucket: 'aljhamar-7d834.firebasestorage.app',
    messagingSenderId: '222287467199',
    appId: '1:222287467199:web:79b7a7d772fb1af3e06c0a',
    measurementId: 'G-S875GQ5VNV',
    vapidKey:
      'BA_Ydew4u2x05yLI1f0IWJBRlqKVGIYR80qoN6moN2N52Fq4pLOw2GJFcM9y5FOL-uhVOelMzc9alxMLMprDf70',
  },
  aljhamar_back: 'FD58coROgWq4MYv',
  aljhamar_front: 'Ttvoskb21W1ABqbE',
  /**
   * Enlace público de un producto en la tienda web ({slug} o {id} como
   * marcadores). Es la ruta canónica de aljhamar-online-store (/productos/:slug).
   * Vacío = no se muestra el botón «Ver en la web».
   */
  webProductUrl: 'https://aljhamar.com/productos/{slug}',
  whatsapp: 'http://localhost:3000/notify',
};
